import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { DealerProductDetailsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { WheelPartItem } from "./useSearchWheelsByVehicle";

export const useGetWheelByPartId = (
  swrOptions: SWRConfiguration<FetcherResult<WheelPartItem>> = {}
): ModifiedSWRResponse<FetcherResult<WheelPartItem>, WheelPartItem> => {
  const route = useRouteParams(DealerProductDetailsRoute);

  const { data, ...result } = useSwrGet<WheelPartItem>(
    route ? "/retailSiteWebService/parts/wheel/getWheelByPartId.php" : null,
    route
      ? {
          dealerId: route.dealerId,
          partId: route.partId,
          secondaryPartId: route.secondaryPartId,
          vehicleId: route.vehicleId,
        }
      : {},
    swrOptions
  );

  return { ...result, data: Array.isArray(data) ? undefined : data };
};
